module.exports = __webpack_public_path__ + "img/126-Pearl SFTN Mat.jpg";